import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class GarminStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      user: null,
      loading: false,
      username: '',
      brand: 'GARMIN',
      description: '',
      garminToken: '',
      garminTokenSecret: '',
      summaries: null,
      account: null,
    });
  }

  setData(task, data) {
    this[task] = data;
  }

  resetData() {
    this.account = null;
  }

  async getUserToken(username) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/smartwatch/account/gettoken/${username}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const user = res.body || null;
        if (user) {
          this.garminToken = user.userAccessToken;
          this.garminTokenSecret = user.userAccessTokenSecret;
        }
        return user;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getAccessLink(callbackUrl) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/garmin/getaccesslink`;
      const res = await rp
        .post(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          body: {
            callbackUrl,
          },
          headers: {
            ...getTenantHeaders(),
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, PUT, OPTIONS',
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body;
        return data;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRegisterAccount(oauthToken, oauthTokenSecret, oauthVerifier) {
    try {
      let url = `${config.api.url}/${config.api.version}/garmin/register`;
      const res = await rp
        .post(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          body: {
            oauthToken,
            oauthTokenSecret,
            oauthVerifier,
          },
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body || {};
        if (data) {
          this.account = data;
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}
export default new GarminStore();
